import { render, staticRenderFns } from "./Intersection.vue?vue&type=template&id=a87748e0&"
import script from "./Intersection.vue?vue&type=script&lang=js&"
export * from "./Intersection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports